import {
  injectSlice,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@betty/toolkit/state';
import { JackpotsState, Jackpot } from './jackpots.types';
import JackpotsService from '../../services/JackpotsService/JackpotsService';

export const fetchJackpots = createAsyncThunk(
  'jackpots/fetch',
  async (_, { dispatch }) => {
    const { jackpots } = await JackpotsService.getJackpots();

    dispatch(setJackpots(jackpots));
  },
);

const initialState: JackpotsState = {
  data: {},
  dataState: 'idle',
};

const jackpots = createSlice({
  name: 'jackpots',
  initialState,
  reducers: {
    setJackpots(state, { payload: jackpots }: PayloadAction<Jackpot[]>) {
      jackpots.forEach((jackpot) => {
        const { gameId } = jackpot;

        state.data[gameId] = jackpot;
      });

      state.dataState = 'fulfilled';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJackpots.pending, (state) => {
      state.dataState = 'pending';
    });

    // builder.addCase(fetchJackpots.fulfilled, (state, action) => {
    //   state.dataState = 'fulfilled';
    //   state.data = action.payload;
    // });
    builder.addCase(fetchJackpots.rejected, (state) => {
      state.dataState = 'rejected';
    });
  },
});

export const withJackpots = injectSlice({
  reducerPath: 'jackpots',
  reducer: jackpots.reducer,
});

export const { setJackpots } = jackpots.actions;

export const selectJackpot = (gameId: Jackpot['gameId']) =>
  withJackpots.selector((state) => state.jackpots.data[gameId]);
export const selectJackpots = withJackpots.selector(
  (state) => state.jackpots.data,
);

export const selectJackpotsState = withJackpots.selector(
  (state) => state.jackpots.dataState,
);

declare global {
  interface LazyLoadedSlices {
    jackpots: ReturnType<typeof jackpots.reducer>;
  }
}
